const ProductRatesListCtrl = ['$scope', '$filter', 'UserInfo', 'Alert', 'Task', '$location', '$routeParams', 'filtersUtils',
    function ($scope, $filter, UserInfo, Alert, Task, $location, $routeParams, filtersUtils) {
        /***********************************************************************************************************
        * Controller Attributes
        ***********************************************************************************************************/
        var $translate = $filter('translate');

        $scope.primaryKey = 'code'

        $scope.PRODUCT_RATE_LIST_RESULT = require('../../templates/product-rate-list-result.html')


        $scope.filters = {
            'loaded': true
        };

        if($scope.loaded === undefined){
            $scope.loaded = false;
        };

        if(Object.keys($routeParams).length == 0){
            $scope.filters = {
                "visibility": "VISIBLE",
                "not_in_force": "0"
            }
        }

        $scope.files = []

        /***********************************************************************************************************
        * Scope Attributes
        ***********************************************************************************************************/
        $scope.products_rates = [];
        $scope.ordering = {
            "code": $translate('PRODUCTS.CODE'),
            "name": $translate('PRODUCTS.NAME')
        };
        $scope.statuses = [
            { code: 'VISIBLE', label: $translate('PRODUCTS.VISIBLE')},
            { code: 'INVISIBLE', label: $translate('PRODUCTS.INVISIBLE')}
        ];

        $scope.invoicing_modes = [
            {code: 'NOR', label: 'Normal'},
            {code: 'IND', label: 'Indexada'},
            {code: 'INB', label: 'Indexada sin elevar a barras'},
            {code: 'INM', label: 'Indexada Mixta'},
            {code: 'Q11', label: 'Q101'},
            {code: 'CAS', label: 'Fijo con costes indexados'}
        ]

        $scope.validity = [
            { code: '0', label: $translate('PRODUCTS.IN_FORCE')},
            { code: '1', label: $translate('PRODUCTS.NOT_IN_FORCE')}
        ];

        $scope.mode = 'list';
        $scope.counter = 0;

        $scope.notInForceOptions = [
            { value: true, label: $translate('PRODUCTS.YES') },
            { value: false, label: $translate('PRODUCTS.NO') }
        ];

        $scope.changeVisibilityData = { visibility: null, not_in_force: null };

        /***********************************************************************************************************
        * Scope Watchers
        ***********************************************************************************************************/
        $scope.$on('refreshRates', function (event) {
            $scope.listReload();
        });

        $scope.$on('selectedCounterChange', function (e, count) {
            $scope.counter = count;
        });

        /***********************************************************************************************************
        * Controller Methods
        ***********************************************************************************************************/

        /***********************************************************************************************************
        * Scope Methods
        ***********************************************************************************************************/
        $scope.getStyles = function(result){
            var styles = ''
            if(result.visibility === 'VISIBLE')
                styles += ' '+'success';
            if(result.visibility === 'INVISIBLE')
                styles += ' '+'danger';

            if(styles ===''){
                styles += ' '+'info';
            }

            return styles
        };

        $scope.showCreateRateForm = function() { $scope.mode = 'create'; };
        $scope.hideCreateRateForm = function() { $scope.mode = 'list'; };

        $scope.canCreateProductRate = function () {
            return (UserInfo.hasPerm("products.add_productrate"));
        };

        $scope.canChangeProductRate = function () {
            return UserInfo.hasPerm('products.change_productrate');
        };

        $scope.resetChangeVisibilityForm = function () {
            $scope.changeVisibilityData = { visibility: null, not_in_force: null };
        };

        $scope.executeChangeVisibility = function () {
            var ids = filtersUtils.getItemsToDownload($scope.itemsToDownload);
            var task = new Task();
            task.type = 'SPRV';
            task.params = {
                ids: ids,
                visibility: $scope.changeVisibilityData.visibility
            };
            if ($scope.changeVisibilityData.not_in_force !== null && $scope.changeVisibilityData.not_in_force !== undefined) {
                task.params.not_in_force = $scope.changeVisibilityData.not_in_force;
            }
            task.start().then(function (data) {
                Alert.createAlert('success', $translate('PRODUCTS.CHANGE_VISIBILITY_SUCCESS'), true);
                $scope.changeVisibilityData = { visibility: null, not_in_force: null };
                $('#changeVisibilityModal').modal('hide');
            }, function () {
                Alert.createAlert('danger', $translate('PRODUCTS.CHANGE_VISIBILITY_ERROR'), true);
            });
        };

        $scope.downloadTemplate = function () {
            if ($scope.counter != 0) {
                var task = new Task();
                task.type = 'PRET';

                task.params = {
                    'ids': Object.keys($scope.itemsToDownload),
                    'filters': $scope.filters
                }

                task.start().then(function (data, status, headers, config) {
                    Alert.createAlert('success', $translate('PRODUCTS.DOWNLOADING_TEMPLATE'), true);
                    $scope.backgroundTasks.push(data.data.id);
                }, function (data, status, headers, config) {
                    Alert.createAlert('danger', $translate('PRODUCTS.ERROR_DOWNLOADING_TEMPLATE'), true);
                });
            }
        };


        $scope.uploadTemplate = function() {

            var filesIDs = [];
            angular.forEach($scope.files, function(value, key) {
                filesIDs.push(value.id);
            });

            var task = new Task();
            task.type = 'PRIT'
            task.params = {files: filesIDs};

            task.start().then(function(response, status, headers, config) {
                    Alert.createAlert('info', $translate('UPLOADER.IMPORT_BACKGROUND'), false);
                    $scope.backgroundTasks.push(response.data.id);
                }, function(response, status, headers, config) {
                    Alert.createAlert('danger', $translate('UPLOADER.ERROR_SENDING_TASK'), false);
                });
            $scope.files = []
        };

        $scope.$watchCollection('filters', function (newVal, oldVal) {
            angular.forEach(newVal, function (value, key) {
                if(value){
                    $location.search(key, value)
                }else{
                    $location.search(key, null)
                }
            })
        });

        angular.forEach($routeParams, function (value, key) {
            if(key !== undefined){
                $scope.filters[key] = value
            }
        })
    }
]

export { ProductRatesListCtrl }
